(function ($) {
  'use strict';

  addToHomescreen();

  $(document).ready(function () {

    // Navbar initialization
    $(window).resize(function(){
      setTimeout($('#ctl00_dvTopNavigation').navbarSticky({
        paddingEl: '#dvCustomMasthead',
        stickyClass: 'fixed-top'
      }),1000);
    });

    $('#ctl00_dvTopNavigation').navbarSticky({
      paddingEl: '#dvCustomMasthead',
      stickyClass: 'fixed-top'
    });

    var mobileNavEl = $('#ctl00_dvTopNavigation .visible-xs.visible-sm .pes-navbar').first();
    mobileNavEl.navbarOffcanvas();

    // Offcanvas Utility Menu Toggle
    $('#dvCustomMasthead>#utilityMenu').navbarOffcanvas();

    // Unbind a2z's navbar hover
    $('.navbar-nav li.dropdown').unbind('mouseenter mouseleave');

    // This overrides an Android-specific a2z method
    $('.navbar-nav li.dropdown > a').unbind('click');

    // site footer date
    $('#pes-copyright-year').html(new Date().getFullYear());

    // clean up sessions headings
    $('#sessionsBlock').sessionsHeadings();

    // utility navbar login swap
    $('.pes-login-swap').loginSwap();

    // carousel
    $('[data-plugin="pesCarousel"]').extCarousel();

    // extended modal function
    $('[data-plugin="extModal"]').extModal();

    // toggle all for Bootstrap collapse groups
    $('[data-plugin="collapse-toggle-all"]').collapseToggleAll();

    // animate anchor scrolls
    $('[data-plugin="scroll-animate"]').scrollAnimate({
      offset: 65
    });

    // Social share links
    $("#jssocials").jsSocials({
      shareIn: "blank",
      showLabel: false,
      showCount: false,
      shares: ["facebook", "twitter", "linkedin"]
    });

  });
}(jQuery));
